export default __webpack_public_path__ + "static/convecteur-2febd3933c9fb66133d39b75918e198b.jpg";